import { useState } from 'react';
import { signKeyProof } from '@timecapsule/crypto/keyproof';
import { api } from '../api';
import { Footer, PublicHeader } from '../App';
import { errorText, useT } from '../i18n';
import { PhraseInput } from './KeySetup';

/** Existing identity recovery does not register a temporary account or allocate a pilot seat. */
export function RecoverAccess() {
  const t=useT(),p=t.pilotAdmin;
  const [key,setKey]=useState<Uint8Array|null>(null),[busy,setBusy]=useState(false),[error,setError]=useState<string|null>(null);
  const complete=async()=>{if(!key)return;setBusy(true);setError(null);try{const {challenge}=await api.recoveryChallenge();await api.recoverAccess({challenge,proof:signKeyProof(challenge,key)});key.fill(0);setKey(null);location.href='/restore';}catch(e){setError(errorText(e));setBusy(false);}};
  return <><PublicHeader/><main className="narrow"><h1>{p.recover}</h1><p>{p.recoverHelp}</p><PhraseInput onKey={setKey} disabled={busy}/><button disabled={!key||busy} onClick={()=>void complete()}>{p.recover}</button>{error&&<p className="error" role="alert">{error}</p>}</main><Footer/></>;
}
